import { atom } from 'recoil';

import { MasterAdvisorProps, MasterStateProps } from './types';

export const defaultAdvisor: MasterAdvisorProps = {
  id: 0,
  name: 'Todos os assessores',
  branchId: 0,
  partnerId: undefined,
  partnerName: '',
  email: '',
  businessEmail: '',
};

export const masterState = atom<MasterStateProps>({
  key: 'masterState',
  default: {
    loaded: false,
    advisorList: [defaultAdvisor],
    partnerList: [],
    selectedAdvisor: undefined,
    selectedPartner: undefined,
    selectedAdvisorGroup: undefined,
  },
});
